import { render, staticRenderFns } from "./Facts.vue?vue&type=template&id=a92377d0&scoped=true&"
import script from "./Facts.vue?vue&type=script&lang=js&"
export * from "./Facts.vue?vue&type=script&lang=js&"
import style0 from "./Facts.vue?vue&type=style&index=0&id=a92377d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92377d0",
  null
  
)

export default component.exports